module.exports = __webpack_public_path__ + "static/property5-1b6dbd845b16098072348d2b201a472c.png";